import styled from 'styled-components';

export const Container = styled.div`
    display: flex;

    align-items: center;
    justify-content: center;
    
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 3rem;
    width: 85%;
    max-width: 800px;

`;

export const TitleDate = styled.h3`
    margin: 4rem 0rem;
`;

export const InfoCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 0rem;
    padding: .6rem 2rem;
    background-color: white;
    border-radius: 10px;

    .info-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 4rem;
    }
    .category {
        color: black;
        font-weight: bold;
        margin: .2rem 0rem;
    }

`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: white;
    font-family: Inter;
    font-weight: bold;
    font-size: large;
    background-color: black;
    padding: 1rem 1rem;
    margin-top: 2rem;
    border-radius: 20px;
`;

export const ButtonSwitch = styled.button`
    display: flex;
    width: 60px;
    height: 30px;
    align-items: center;
    justify-content: center;
    border: none;
    color: white;
    font-family: Inter;
    font-weight: 300;
    font-size: large;
    border-radius: 5px;
    margin: .1rem;
`;